// extracted by mini-css-extract-plugin
module.exports = {"UtilityBoxItem":"utility-box-item_UtilityBoxItem__MLjgN","childWrapper":"utility-box-item_childWrapper__QhWZD","icon":"utility-box-item_icon__2DQWx"};